import React from 'react';
import styles from '../MagicSignTable.module.scss';

interface LockableSelectCellProps {
    /** Keeps the locked pill and the editable control the same width. */
    wrapperClassName: string;
    /** Locks the cell to a read-only pill once the document is sent/signed/cancelled. */
    locked: boolean;
    /** Text shown in the locked pill; falls back to '-' when there's no value. */
    lockedValue?: string;
    lockedTitle?: string;
    children: React.ReactNode;
}

/**
 * Document Type and Sign Type share this shape: a wrapper that fills the column width, containing
 * either a locked read-only pill or an editable control — so a locked row's pill is never a
 * different width from the row above it.
 */
const LockableSelectCell: React.FC<LockableSelectCellProps> = ({ wrapperClassName, locked, lockedValue, lockedTitle, children }) => (
    <div className={wrapperClassName}>
        {locked ? (
            <span className={styles.LockedCellText} title={lockedTitle ?? lockedValue ?? ''}>
                {lockedValue ?? '-'}
            </span>
        ) : (
            children
        )}
    </div>
);

export default LockableSelectCell;
